/* Isolated native-scrolling gallery. Reconnects safely when Theme Editor replaces a section. */
if (!customElements.get('chelin-customer-photos')) {
  customElements.define('chelin-customer-photos', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.chelin-customers__rail');
      this.controls = this.querySelector('.chelin-customers__controls');
      if (!this.rail || !this.controls || this.events) return;
      this.previous = this.querySelector('[data-direction="previous"]');
      this.next = this.querySelector('[data-direction="next"]');
      this.current = this.querySelector('[data-current]');
      this.total = this.querySelector('[data-total]');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.rail.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.rail.addEventListener('keydown', (event) => {
        const directions = { ArrowLeft: -1, ArrowRight: 1 };
        if (!(event.key in directions)) return;
        event.preventDefault();
        this.move(directions[event.key]);
      }, options);
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.rail);
      this.measure();
    }

    measure() {
      const items = Array.from(this.rail.children);
      const max = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
      const first = items[0]?.offsetLeft || 0;
      this.positions = [...new Set(items.map((item) => Math.round(Math.min(max, item.offsetLeft - first))))];
      if (!this.positions.length) this.positions = [0];
      this.controls.hidden = max <= 1;
      this.total.textContent = this.positions.length;
      this.update();
    }

    update() {
      if (!this.positions) return;
      const left = this.rail.scrollLeft;
      this.index = this.positions.reduce((closest, value, index) =>
        Math.abs(value - left) < Math.abs(this.positions[closest] - left) ? index : closest, 0);
      this.current.textContent = this.index + 1;
      this.previous.disabled = left <= 1;
      this.next.disabled = left >= this.rail.scrollWidth - this.rail.clientWidth - 1;
    }

    move(direction) {
      const index = Math.max(0, Math.min(this.positions.length - 1, this.index + direction));
      this.rail.scrollTo({
        left: this.positions[index],
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.events = null;
    }
  });
}
